<template>
  <div class="login-bridge">
    <p>Authenticating...</p>
  </div>
</template>

<script>
export default {
  name: 'LoginBridge',
  mounted() {
    const token = decodeURIComponent(this.$route.query.token);

    if (!token) {
      window.location.href = '/login';
      return;
    }

    localStorage.setItem('yup_chat_token', JSON.stringify(token));
    window.location.href = '/';
  },
};
</script>
